import { render, staticRenderFns } from "./MerchantWalletFilter.vue?vue&type=template&id=00b6fea6&"
import script from "./MerchantWalletFilter.vue?vue&type=script&lang=js&"
export * from "./MerchantWalletFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports